<div #chartPreviewDiv class="chart-preview-container"></div>